/**
 * @description Component-PairNotInWhitelist
 */
import { THEME_ENUM } from '@/constants';
import './index.less';

import { Button } from '@/components/Button';
import { WrappedPair } from '@/entities/WrappedPair';
import { useTheme } from '@/features/global/hooks';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MailIcon from './assets/icon_mj_mail.png';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  currentPair: WrappedPair | undefined;
}
const PairNotInWhitelist: FC<IPropTypes> = function ({}) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className="syn-earn-area syn-pair-not-in-whitelist">
      <div className="syn-earn-area-container">
        <div className="syn-earn-area syn-pair-not-in-whitelist-header">
          {
            <>
              {t('common.earn.whiteListTitleDot')} <a href="mailto:info@synfutures.com">{t('common.contactUs')}</a>
            </>
          }
        </div>
        {<img src={theme.dataTheme === THEME_ENUM.DARK ? MailIcon : MailIcon} />}
        <div className="syn-earn-area-container-titles">
          {
            <>
              <div className="syn-earn-area-container-titles-up">{t('common.earn.whiteListTitle')}</div>
              <div className="syn-earn-area-container-titles-sub">{t('common.earn.whiteListSubTitle')}</div>
            </>
          }
        </div>
        {
          <Button type="primary" block href="mailto:info@synfutures.com">
            {t('common.contactUs')}
          </Button>
        }
      </div>
    </div>
  );
};

export default PairNotInWhitelist;
